// extracted by mini-css-extract-plugin
module.exports = {"ldsSpinner":"Loader-module-ldsSpinner--bzuRg","lds-spinner":"Loader-module-lds-spinner--NRHjW"};